var p2 = "/static/994f3c37322f9b13.png";

export { p2 as default };
//# sourceMappingURL=p_2.png.js.map
